module.exports = __webpack_public_path__ + "img/yeah_motiv1.b694db8f.jpg";